import { render, staticRenderFns } from "./CRUDTurnosPassageiros.vue?vue&type=template&id=d3108864&"
import script from "./CRUDTurnosPassageiros.vue?vue&type=script&lang=js&"
export * from "./CRUDTurnosPassageiros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports